import React from 'react';
import { IDroneLabelResult } from '../../../../../common/src/domain/customInspectionTypes/inspectionLabel/droneLabel/IDroneLabelResult';
import { EditPanelCell, EditPanelRow, PanelBody, PanelHeading, PanelWithoutForm } from '../../../components/elements';
import { useReactAsync } from '../../../components/utils/useReactAsync';
import { fetchGet } from '../../../store/fetch';
import { GenericInspectionLabel } from '../common/GenericInspectionLabel';

async function loadInspectionStandardData({ surveyId }: { surveyId: string }) {
    const result = await fetchGet(`/api/surveys/${surveyId}/inspectionStandardData/droneLabel`);
    return result.json as IDroneLabelResult;
}

export function SurveyDetailsDroneLabel(props: { surveyId: string }) {
    const { data } = useReactAsync(loadInspectionStandardData, { surveyId: props.surveyId }, []);

    if (!data) {
        return null;
    }

    return (
        <PanelWithoutForm id="DroneLabel">
            <link href="https://fonts.googleapis.com/css?family=Bitter:400,400italic,700" rel="stylesheet" type="text/css"></link>
            <PanelHeading text="Drone label" icon="fa fa-tag"></PanelHeading>
            <PanelBody whiteBackground={true}>
                <EditPanelRow>
                    <EditPanelCell rowCount={6}>
                        <GenericInspectionLabel
                            inspectionType="regular"
                            veiligheidsrisicoscoreVoorDeInspecteurLabelScore={
                                data.reguliereInspectieVeiligheidsrisicoscoreVoorDeInspecteurDroneLabelScore
                            }
                            veiligheidsrisicoscoreVanDeVaarWeggebruikerLabelScore={
                                data.reguliereInspectieVeiligheidsrisicoscoreVanDeVaarWeggebruikerDroneLabelScore
                            }
                            veiligheidsrisicoscoreVanHetLuchtvaartverkeerLabelScore={
                                data.reguliereInspectieVeiligheidsrisicoscoreVanHetLuchtvaartverkeerDroneLabelScore
                            }
                            veiligheidsrisicoscoreVanHetObjectLabelScore={data.reguliereInspectieVeiligheidsrisicoscoreVanHetObjectDroneLabelScore}
                            deHinderVoorHetWegverkeerLabelScore={data.reguliereInspectieDeHinderVoorHetWegverkeerDroneLabelScore}
                            milieuLabelScore={data.reguliereInspectieMilieuDroneLabelScore}
                            kostenLabelScore={data.reguliereInspectieKostenDroneLabelScore}
                            overallLabelScore={data.reguliereInspectieOverallDroneLabelScore}
                            veiligheidsrisicoscoreVoorDeInspecteurScore={data.reguliereInspectieVeiligheidsrisicoscoreVoorDeInspecteurScore}
                            veiligheidsrisicoscoreVanDeVaarWeggebruikerScore={data.reguliereInspectieVeiligheidsrisicoscoreVanDeVaarWeggebruikerScore}
                            veiligheidsrisicoscoreVanHetLuchtvaartverkeerScore={
                                data.reguliereInspectieVeiligheidsrisicoscoreVanHetLuchtvaartverkeerScore
                            }
                            veiligheidsrisicoscoreVanHetObjectScore={data.reguliereInspectieVeiligheidsrisicoscoreVanHetObjectScore}
                            kosten={data.reguliereInspectieKosten}
                            deHinderVoorHetWegverkeerKlasse={data.reguliereInspectieDeHinderVoorHetWegverkeerKlasse}
                            deHinderVoorHetWegverkeerCategorie={data.reguliereInspectieDeHinderVoorHetWegverkeerCategorie}
                            naam={data.naam}
                            locatie={data.locatie}
                            omschrijving={data.omschrijving}
                        />
                    </EditPanelCell>

                    <EditPanelCell rowCount={6}>
                        <GenericInspectionLabel
                            inspectionType="drone"
                            veiligheidsrisicoscoreVoorDeInspecteurLabelScore={
                                data.droneInspectieVeiligheidsrisicoscoreVoorDeInspecteurDroneLabelScore
                            }
                            veiligheidsrisicoscoreVanDeVaarWeggebruikerLabelScore={
                                data.droneInspectieVeiligheidsrisicoscoreVanDeVaarWeggebruikerDroneLabelScore
                            }
                            veiligheidsrisicoscoreVanHetLuchtvaartverkeerLabelScore={
                                data.droneInspectieVeiligheidsrisicoscoreVanHetLuchtvaartverkeerDroneLabelScore
                            }
                            veiligheidsrisicoscoreVanHetObjectLabelScore={data.droneInspectieVeiligheidsrisicoscoreVanHetObjectDroneLabelScore}
                            deHinderVoorHetWegverkeerLabelScore={data.droneInspectieDeHinderVoorHetWegverkeerDroneLabelScore}
                            milieuLabelScore={data.droneInspectieMilieuDroneLabelScore}
                            kostenLabelScore={data.droneInspectieKostenDroneLabelScore}
                            overallLabelScore={data.droneInspectieOverallDroneLabelScore}
                            veiligheidsrisicoscoreVoorDeInspecteurScore={data.droneInspectieVeiligheidsrisicoscoreVoorDeInspecteurScore}
                            veiligheidsrisicoscoreVanDeVaarWeggebruikerScore={data.droneInspectieVeiligheidsrisicoscoreVanDeVaarWeggebruikerScore}
                            veiligheidsrisicoscoreVanHetLuchtvaartverkeerScore={data.droneInspectieVeiligheidsrisicoscoreVanHetLuchtvaartverkeerScore}
                            veiligheidsrisicoscoreVanHetObjectScore={data.droneInspectieVeiligheidsrisicoscoreVanHetObjectScore}
                            kosten={data.droneInspectieKosten}
                            deHinderVoorHetWegverkeerKlasse={data.droneInspectieDeHinderVoorHetWegverkeerKlasse}
                            deHinderVoorHetWegverkeerCategorie={data.droneInspectieDeHinderVoorHetWegverkeerCategorie}
                            naam={data.naam}
                            locatie={data.locatie}
                            omschrijving={data.omschrijving}
                        />
                    </EditPanelCell>
                </EditPanelRow>
            </PanelBody>
        </PanelWithoutForm>
    );
}
